<style lang="scss">
.course-list {
    height: 100%;
    overflow: auto;
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
        padding: 0;
        margin: 0 24px;
        line-height: 16px;

        &:not(:first-child) {
            border-top: 1px solid #eff0f1;
        }
    }

    a {
        display: block;
        margin: 12px -24px;
        padding: 0 24px;
        color: #666;

        &:hover {
            color: #f977bd;
            text-decoration: none;
        }
    }
}
</style>

<script lang="ts">
import type { CourseListItem } from '../api/types';
import courses from '../store/courses';

let items: CourseListItem[];
$: items = $courses.list.map(item => $courses.courses[item.id]);
</script>
<ul class="course-list">
    {#each items as item (item.id)}
        <li>
            <a href="#{item.id}">{item.title || item.id} {item.courseTag ? `(${item.courseTag})` : ''}</a>
        </li>
    {/each}
</ul>
